var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 10.4167C16.553 10.4167 13.7497 13.22 13.7497 16.6667C13.7497 20.1133 16.553 22.9167 19.9997 22.9167C23.4463 22.9167 26.2497 20.1133 26.2497 16.6667C26.2497 13.22 23.4463 10.4167 19.9997 10.4167ZM19.9997 20.4167C17.9313 20.4167 16.2497 18.735 16.2497 16.6667C16.2497 14.5983 17.9313 12.9167 19.9997 12.9167C22.068 12.9167 23.7497 14.5983 23.7497 16.6667C23.7497 18.735 22.068 20.4167 19.9997 20.4167ZM19.993 3.75C12.633 3.75 7.08301 9.30333 7.08301 16.6667C7.08301 27.0133 14.9763 33.4599 18.368 35.7499C18.8613 36.0833 19.4263 36.25 19.993 36.25C20.5563 36.25 21.1213 36.0834 21.6147 35.7517C25.013 33.4567 32.9163 27.0017 32.9163 16.665C32.9163 9.30171 27.3613 3.75 19.993 3.75ZM20.2164 33.68C20.078 33.7733 19.9063 33.7733 19.768 33.68C17.378 32.0667 9.58301 26.0717 9.58301 16.6667C9.58301 10.7283 14.058 6.25 19.993 6.25C25.9347 6.25 30.4163 10.7283 30.4163 16.6667C30.4163 25.805 23.283 31.61 20.2164 33.68Z",
    fill: "#39383A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker2);
export default __webpack_public_path__ + "static/media/map-marker2.bc7d5b26.svg";
export { ForwardRef as ReactComponent };